import { render, staticRenderFns } from "./AgentAssist.vue?vue&type=template&id=8d0e2740&scoped=true"
import script from "./AgentAssist.vue?vue&type=script&lang=js"
export * from "./AgentAssist.vue?vue&type=script&lang=js"
import style0 from "./AgentAssist.vue?vue&type=style&index=0&id=8d0e2740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0e2740",
  null
  
)

export default component.exports